import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { EnquiryDialog } from "../components/EnquiryDialog";
import { IMAGES } from "../data/site";
import { Users, Heart, Shield, Award } from "lucide-react";

const STATS = [
  { n: "500+", label: "Happy Journeys" },
  { n: "12+", label: "Kerala Destinations" },
  { n: "4.9★", label: "Average Rating" },
  { n: "24x7", label: "On-Trip Support" },
];
const VALUES = [
  { icon: Heart, title: "Genuine Care", text: "We treat every traveller like family — because your holiday matters to us as much as it does to you." },
  { icon: Shield, title: "Complete Trust", text: "Transparent pricing, verified drivers and inspected hotels. No hidden costs, ever." },
  { icon: Users, title: "Personal Touch", text: "A dedicated expert on WhatsApp from your first enquiry to your safe return home." },
  { icon: Award, title: "Kerala Expertise", text: "We focus only on Mumbai to Kerala — so we know every road, resort and hidden gem." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero eyebrow="About Us" title={["Mumbai's specialists", "for Kerala."]}
        subtitle="Kerala Holidays Connect exists for one purpose — to make your journey from Mumbai to God's Own Country effortless, comfortable and unforgettable." image={IMAGES.munnarValley} />

      <section className="max-w-[1200px] mx-auto px-5 lg:px-10 py-24">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <p className="eyebrow text-gold mb-4">Our Story</p>
            <h2 className="font-serif text-3xl lg:text-5xl font-light text-emerald leading-tight">Born from a love for Kerala, built on trust.</h2>
            <p className="text-ink/60 mt-6 leading-relaxed">What began as helping friends and family plan their Kerala holidays grew into a dedicated travel company serving hundreds of travellers from Mumbai each year. We specialise in one route and one promise — a seamless, premium Kerala experience.</p>
            <p className="text-ink/60 mt-4 leading-relaxed">From honeymooners drifting through Alleppey to large corporate groups exploring Munnar, every journey is crafted with the same attention to detail and genuine warmth.</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="overflow-hidden clip-arch h-[480px]">
              <img src={IMAGES.hotel} alt="Comfortable stays" className="w-full h-full object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-24 border-y border-emerald/10 py-12">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="text-center">
                <p className="font-serif text-5xl lg:text-6xl text-emerald font-light">{s.n}</p>
                <p className="eyebrow text-gold mt-2">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-24">
          <Reveal><p className="eyebrow text-gold mb-4">What We Stand For</p>
            <h2 className="font-serif text-3xl lg:text-5xl font-light text-emerald mb-12 max-w-2xl">Values that shape every journey.</h2></Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08}>
                <div className="border-t border-emerald/15 pt-6">
                  <v.icon className="w-8 h-8 text-gold" />
                  <h3 className="font-serif text-2xl text-emerald mt-4">{v.title}</h3>
                  <p className="text-ink/60 text-sm mt-3 leading-relaxed">{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal>
          <div className="mt-24 bg-emerald text-cream p-12 lg:p-20 text-center grain relative overflow-hidden">
            <div className="relative z-10">
              <h2 className="font-serif text-3xl lg:text-5xl font-light max-w-2xl mx-auto leading-tight">Let's plan your perfect Kerala holiday together.</h2>
              <div className="mt-8 flex justify-center">
                <EnquiryDialog title="Get a Free Quote" trigger={
                  <button className="bg-gold text-white px-10 py-4 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-cream hover:text-emerald transition-colors" data-testid="about-cta-btn">Get Your Free Quote</button>
                } />
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
